import forOwn from 'mout/object/forOwn'
import sortByPropText from '../../helpers/content/manageSets/sortByPropText'
import { 
  autoTutorSentences,
  skillWeights,
  tsDataEnglish,
  tsDataMath,
  tsDataReading,
  tsDataScience,
  autoTutorSentencesStudent,
} from '../../data'

// Generates the auto-tutor recommendations
export default function getAutoTutorRecommendations({byNode, bySubtest, subject, nodes}, isStudent, isGroup) {
  const selectTsData = {
    English: tsDataEnglish,
    Math: tsDataMath,
    Reading: tsDataReading,
    Science: tsDataScience,
  }
  const tsData = selectTsData[subject]

  if (!tsData) {
    return Error(`subject must be English, Math, Reading, or Science. Submitted ${subject}`)
  }

  // checks for tsData existing at scale scores we need
  function getTsDataCheck(nodeName, scale) {
    let checkScales = [0, 1, 2]
    checkScales = checkScales.map((num) => {
      return `scale${num + scale}`
    })
    let check = true
    checkScales.forEach((checkScale) => {
      if (!tsData[checkScale]) {
        check = false
      } else if (!(nodeName in tsData[checkScale])) {
        check = false
      }
    })
    return check
  }
  
  // find top three skills
  function getTopThreeSkills(byNode, bySubtest, subject, nodes, isStudent) {
    // for each byNode percent correct, multiply by -3, then add percent corrects from tsData for same scale, +1, and +2, then multiply by skillWeights
    let values = []
    const scale = Math.round(bySubtest.scale)
    forOwn(byNode, ({percentage}, key) => {
      if (key in nodes) {
        const nodeName = nodes[key].name
        const skillWeightsCheck = nodeName in skillWeights[subject]
        const tsDataCheck = getTsDataCheck(nodeName, Math.round(bySubtest.scale))
        const sentencesCheck = nodeName in autoTutorSentences[subject]
        const studentSentencesCheck = nodeName in autoTutorSentences[subject]
        if (skillWeightsCheck && tsDataCheck && sentencesCheck && (isGroup || studentSentencesCheck)) {
          const tsTotals = tsData[`scale${scale}`][nodeName] + tsData[`scale${scale + 1}`][nodeName] + tsData[`scale${scale + 2}`][nodeName]
          const value = ((percentage * -3) + tsTotals) * (skillWeights[subject][nodeName] * 100)
          values.push({name: nodeName, value}) 
        } else if (!Number.isNaN(scale) && scale !== 'NaN' && scale > 0) {
          // helps detect if we have a key mismatch between our data sources
        }
      }
    })
    const sortedSkills = sortByPropText(values, 'value').reverse()
    const topThreeSkills = sortedSkills.slice(0,3)
    // converts top three skills into recommendations
    const recommendations = topThreeSkills.map(({name}) => {
      if (!isGroup) {
        return autoTutorSentencesStudent[subject][name]
      } else return autoTutorSentences[subject][name]
    })
    if (!isStudent) {
      return recommendations    
    } else {
      return topThreeSkills[0]
    }


    // omit any skills that don't show up in either byNode, skillWeights, tsData, or autoTutorSentences
  }
  // convert top three skills to auto-tutor text

  return getTopThreeSkills(byNode, bySubtest, subject, nodes, isStudent)

  // return top three text
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getAutoTutorRecommendations.js